import { useCallback, useEffect, useRef, useState } from "react";
import is from "@sindresorhus/is";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";

import ImagePlaceholder from "../ImagePlaceholder/ImagePlaceholder";
import Popup from "../Popup/Popup";

import ChevronLeft from "../../../icons/ChevronLeft";
import ChevronRight from "../../../icons/ChevronRight";

import actions from "../../../data/actions";

const HEIGHT_XS = 400;
const HEIGHT_SM = 500;
const HEIGHT_MD = 600;

const Highlights = props => {
  const theme = useTheme();

  const [currentPost, setCurrentPost] = useState();
  const [popupOpen, setPopupOpen] = useState(false);
  const [posts, setPosts] = useState();

  const bgcolor = theme.palette.background.paper;
  const color = theme.palette.getContrastText(bgcolor);

  const onSlideChange = useCallback(
    swiper => {
      setCurrentPost(swiper.realIndex >= 0 && swiper.realIndex < posts.length ? posts[swiper.realIndex] : null);
    },
    [posts]
  );

  const popupOnClose = useCallback(() => setPopupOpen(false), []);
  const postOnClick = useCallback(() => setPopupOpen(true), []);

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  // posts -> currentPost
  useEffect(() => setCurrentPost(is.nonEmptyArray(posts) ? posts[0] : null), [posts]);

  // (init) -> posts
  useEffect(() => {
    Promise.resolve()
      .then(() => actions.getHighlightedPosts())
      .then(posts => setPosts(posts))
      .catch(error => console.log(error));
  }, []);

  return (
    <>
      {is.plainObject(currentPost) && is.nonEmptyArray(posts) && (
        <>
          <Paper elevation={0} square sx={{ /*background: `linear-gradient(0deg, ${bgcolor2} 30%, ${bgcolor} 30%)`,*/ bgcolor, color }}>
            <Container disableGutters maxWidth="lg">
              <Swiper
                navigation={{
                  prevEl: navigationPrevRef.current,
                  nextEl: navigationNextRef.current
                }}
                modules={[Navigation, Pagination]}
                onBeforeInit={swiper => {
                  swiper.params.navigation.prevEl = navigationPrevRef.current;
                  swiper.params.navigation.nextEl = navigationNextRef.current;
                }}
                onSlideChange={onSlideChange}
                pagination={{ clickable: true }}
                loop
                style={{ "--swiper-pagination-color": "#fff" }}
              >
                {posts.map((post, index) => (
                  <SwiperSlide key={index} style={{ "--swiper-pagination-color": "#fff" }}>
                    {is.plainObject(post.featuredMedia.sourceUrl) ? (
                      <Box
                        sx={{
                          backgroundImage: `url(${post.featuredMedia.sourceUrl.full})`,
                          backgroundPosition: "center",
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          height: { xs: HEIGHT_XS, sm: HEIGHT_SM, md: HEIGHT_MD }
                        }}
                      />
                    ) : (
                      <ImagePlaceholder size={HEIGHT_XS * 0.8} sx={{ height: { xs: HEIGHT_XS, sm: HEIGHT_SM, md: HEIGHT_MD } }} />
                    )}
                  </SwiperSlide>
                ))}
                <Box className="swiper-button-prev" ref={navigationPrevRef} sx={{ pl: 1 }}>
                  <IconButton>
                    <ChevronLeft />
                  </IconButton>
                </Box>
                <Box className="swiper-button-next" ref={navigationNextRef} sx={{ pr: 1 }}>
                  <IconButton>
                    <ChevronRight />
                  </IconButton>
                </Box>
              </Swiper>
              <Box
                onClick={() => postOnClick(currentPost)}
                sx={{ background: theme.palette.background.paperAlt, display: { cursor: "pointer", xs: "block", sm: "block" }, p: 2 }}
              >
                <Typography component="div" variant="body2" sx={{ color: theme.palette.primary.main, textTransform: "uppercase" }}>
                  {currentPost.title}
                </Typography>
                <Typography component="div" variant="caption" sx={{ color: theme.palette.text.secondary, pb: 0.5 }}>
                  {currentPost.date}
                </Typography>
                <Typography component="div" variant="body1">
                  {currentPost.excerpt.plain}
                </Typography>
              </Box>
            </Container>
          </Paper>
          <Popup open={popupOpen} onClose={popupOnClose}>
            <Typography variant="h6" sx={{ color: theme.palette.primary.main }}>
              {currentPost.title}
            </Typography>
            <Typography component="div" variant="caption" sx={{ color: theme.palette.text.secondary, pb: 0.5 }}>
              {currentPost.date}
            </Typography>
            {currentPost.content.html}
          </Popup>
        </>
      )}
    </>
  );
};

export default Highlights;
